import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    Position,
    ColumnChooser,
    Paging,
    Pager,
    Form,
    ToolbarItem,
    Editing, HeaderFilter,
    Selection, Scrolling
    , Export, Summary, TotalItem,
    GroupPanel,
    Grouping,
    GroupItem
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import { parseDate } from "../../utils/Utils";

const KanunsuzBildirimDetayForm = (props) => {

    const dispatch = useDispatch();

    const listeBasligi = "Kanunsuz Bildirim Detay";
    const [store, setStore] = useState(null);


    useEffect(() => {
        setStore(getStore());
    }, [])

    let dataGrid = null;


    const getStore = () => {

        return new CustomStore({
            key: 'id',
            load: function () {
                const request = new Request("/home/getKanunsuzBildirimDetayList/"+props.data.domainId, "GET");

                return request.run()
                  .then(response => {
                    if (response.data) {
                      return {
                        data: response.data.data,
                        totalCount: response.data.data.length,
                        summary: 0,
                        groupCount: 0
                      };
                    } else {
                      return []
        
                    }
                  });  
            }
        });
    }


    function siraRender(data) {
        return (data.rowIndex + 1);// <b>{(data.rowIndex +1)}</b> ;
    }



    return (
        <div >
            <DataGrid
                ref={ref => dataGrid = ref}
                width="100%"
                height="500px"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
            //remoteOperations={true}
            >
                <FilterRow visible={true} />
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={10} /> */}

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
              
                <Column dataField={'yil'}  width={40} caption={'Yıl'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'ay'} width={40} caption={'Ay'} dataType="string" mappingType="String" visible={true} /> 
                <Column dataField={'tckimlik'} width={100} caption={'Tckimlik'} dataType="string" visible={true}  />
                <Column dataField={'tarih'} width={100} caption={'Tarih'} dataType="string" visible={true}  />
                <Column dataField="kanun" width={70} caption={'Kanun'}  visible={true}     />
                <Column dataField={'durum'}  width={50} caption={'Durum'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'hata'} width={90} caption={'Hata'} dataType="string" mappingType="String" visible={true} />

            </DataGrid>

        </div>
    )
}

export default KanunsuzBildirimDetayForm;
